const styles = {
  characterisctics: {
    display: "flex",
    alignItems: "center"
  },
  paginate: { gap: "10px", marginTop: "20px", marginBottom: "0px" },
  modal_form: {
    width: "100%",
  },
  error_message: {
    color: "red",
  },
  button: {
    marginTop: "20px",
  },
  radioMargin: {
    marginTop: "20px"
  },
  radioPadding: {
    padding: "5px",
    marginLeft: "7px",
  },
  classCellWidth: {
  },
  removeButton: {
    color: "red", background: "none",
  },
  roleCellWidth: {
  },
  PupilImportFiled: {
    width: "auto",
    height: "51px",
    position: "inherit",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "50px 106px 71px 121px",
    borderRadius: "50px",
    border: "1px solid #fff",
    background: "#f2f2f2"
  },
  PupilImportCard: {
    width: "auto",
    borderRadius: "15px",
    backgroundColor: "#26C8B9",
  },
  PupilImportDiv: {
    marginTop: "100px",
    marginLeft: "-40px"
  },
  PupilImportRow: {
    display: "flex",
    justifyContent: "center"
  },
  inviteUserCol: {
    display: "flex",
    flexDirection: "column",
  },
  inviteUserSelectDiv: {
    display: "flex",
    flexDirection: "row",
  },
  inviteUserSelectClass: {
    width: "48%",
    marginRight: "10px",
    fontWeight: "bold"
  },
  inviteUserSelectSub: {
    width: "48%",
    fontWeight: "bold"
  },
  inviteUserSelectResult: {
    width: "48%",
    marginRight: "20px",
  },
  inviteUserMar: {
    marginTop: "20px"
  },
  tableStyle: {
    background: "var(--table-backgound-color)",
    marginTop: "-16px",
    borderRadius: "0px 20px 20px 20px",
    border: "1px solid rgba(0, 0, 0, 0.23)"
  },
  inviteTableStyle: {
    background: "var(--table-backgound-color)",
    borderRadius: "20px 20px 20px 20px",
    border: "1px solid rgba(0, 0, 0, 0.23)"
  },
  ProgressBarCCTitle: {
    color: "#011C25",
    fontSize: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontFamily: "var(--Manrope-font-generic)"
  },
  progressBarLeftBorder: {
    borderLeft: "3px solid #084059",
    padding: "0px"
  },
  progressBarCC: {
    backgroundColor: "#ffff",
    borderRadius: "0 10px 10px 0",
    width: "90%",
    position: "relative",
    marginTop: "7px",
    marginBottom: "7px"
  },
  percentageMarkedCC: {
    marginLeft: "10px",
    width: "38px",
    fontWeight: 700,
  },
  wondeButton: {
    backgroundColor: "red",
    height: "50px",
    width: "230px",
    borderRadius: "5px",
    color: "#ffff",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

}

const tableSize = 10;
const tableSizeP = 12;
export { styles, tableSize, tableSizeP };